import { useLayoutEffect, useState } from 'react'
import * as PIXI from 'pixi.js-legacy'

import app from 'common/builder/components/chart/FlowChart/app'
import { StatsPopoverPossibleNode } from 'common/builder/components/chart/FlowChart/StatsPopover/lib/types'

export const usePopoverPosition = ({ entityId }: { entityId: string | null }) => {
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
  })

  useLayoutEffect(() => {
    if (!entityId) {
      return
    }

    let node = app.getNode(entityId)

    if (!node) {
      return
    }

    node = (node.ctx || node) as StatsPopoverPossibleNode

    const point = new PIXI.Point()

    let width = 0
    let height = 0

    if (node.layout) {
      width = node.layout.width
      height = node.layout.height
    } else {
      const bounds = node.getBounds(true)
      width = bounds.width / app.transform.k
      height = bounds.height / app.transform.k
    }

    const origin = new PIXI.Point(width, height / 2)
    node.toGlobal(origin, point, true)

    const { x, y } = point

    setPosition({
      top: y,
      left: x,
    })
  }, [entityId])

  return {
    position,
  }
}
